module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-note"
  }, [_c('div', {
    staticClass: "share-note__container"
  }, [_c('div', {
    staticClass: "share-note__copy"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteUrl),
      expression: "noteUrl"
    }],
    staticClass: "share-note__url",
    attrs: {
      "id": "share-note-url",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.noteUrl)
    },
    on: {
      "focus": _vm.selectUrl,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "share-note__button",
    attrs: {
      "data-clipboard-text": _vm.noteUrl,
      "id": "clipboardjs"
    },
    on: {
      "click": _vm.onCopyLink
    }
  }, [_vm._v("\n        " + _vm._s(_vm.copyButtonText) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-note__permission"
  }, [_c('button', {
    staticClass: "share-note__checkbox",
    class: _vm.activeNote.is_public ? 'on' : 'off',
    on: {
      "click": _vm.onTogglePermission
    }
  }, [_vm._v("\n        " + _vm._s(_vm.activeNote.is_public ? "On" : "Off") + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "share-note__info"
  }, [_vm._v("Anyone with the link can view")])])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.onDone
    }
  }, [_vm._v("\n    Done\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5daa821b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Foot/FootShareNote.vue
// module id = 2152
// module chunks = 0